<template>
  <!-- <a
    href="itms-services://?action=download-manifest&url=https://web.gulutest.com/page/download/plist?key=MTY5MDIwNzYzOJyygM7IfHmHj4+VnYCco6FuZGeUmquIuGl/mZBpaI2zgKKtz76ija2Qf9ydiomFoYiZe5zHa2nXjaF2qJiLopeDpmfTyGamoYJ7rqGaeXqOnJ2om7Sig9GYe4Kwg5+t3I98b9zIZ4StkGu6pJuKhqScY4Knvmty1ox2aa2NiW/TkI9v4MZ7o56XpdCdg4Z9soZ0dmSyjZKVg4dxa4GHg96EomvWyHt8oYJ7rqGQZG2tj4h7pa6jqMuVe4Jpl3uDnI98b8mxZ5ukj6GZn5uJrGmdd4esyXxuzJZlYZyAZozdmYBvzr98hZuCaqqomnirrpqHf6jHpbDYgZ1xsoGtd5mEjYTJsWaMbY+iqWSRiXlsk3eCZ7+jg8+BoHlpg4d7l5CjeM+ye4hrkKW9YoRkhW2FnnOnv7NylISHdWuDh3ffhH2Z3bKunqGciaFu">
    123123
  </a> -->
  <template v-if="true">
    <template v-if="alreadyLoaded">
      <template v-if="isWeChat">
        <div class="wechat">
          <img src="@/assets/top-arrow.png" class="top-arrow" />
          <!-- <img style="width: 100vw; height: auto;" src="@/assets/wechat.jpg" /> -->
          <div class="wechat-text m-t-2">
            <div class="flex-center">1</div>
            <div>
              {{ $t(`请点击右上角`) }}"..."{{ $t(`打开菜单`) }}；<br />{{
                $t(`选择用Safari打开下载`)
              }}
            </div>
          </div>
          <div class="wechat-text">
            <div class="flex-center">2</div>
            <div>{{ $t(`点击下方复制网址按钮，粘贴至Safari打开下载`) }}</div>
          </div>
          <div class="wechat-text">
            <div class="flex-center">3</div>
            <div>{{ $t(`复制网址打开Safari浏览器打开下载`) }}</div>
          </div>
          <div class="flex-center">
            <img
              src="@/assets/blue-bg.png"
              class="wechat-blue"
              v-if="appInfo.guidePage == 1"
            />
            <img
              src="@/assets/green-bg.png"
              class="wechat-blue"
              v-else-if="appInfo.guidePage == 2"
            />
            <img src="@/assets/wechat-bg.png" class="wechat-bg" v-else />
          </div>
        </div>
      </template>
      <template v-else-if="!showError">
        <div class="container c-scroll" id="app_1">
          <div style="width: 100%">
            <img src="@/assets/tip1.png" class="tip1" @click="showModal(1)" />
          </div>
          <div class="flex1">
            <img src="@/assets/bg.png" class="bg" />
          </div>
          <div class="flex tip-content-box">
            <img src="@/assets/tip2.png" class="tip2" @click="showModal(1)" />
            <div>
              <div class="tip-content-title">{{ $t(`请注意`) }}！</div>
              <div class="tip-content-text">
                {{ $t(`您即将访问的应用为用户自行上传，请甄别应用风险后进行下载`) }}！
              </div>
            </div>
          </div>
          <div class="next-btn" @click="showBox2(true)">
            {{ $t(`继续访问`) }}
          </div>
          <div class="p-180"></div>
        </div>

        <div id="app_2" class="c-scroll">
          <div class="download-container flex-col">
            <!-- <img src="@/assets/75-year.png" class="year-75" alt=""> -->
            <div class="flex-col flex1">
              <template v-if="isPassword">
                <img src="@/assets/download-icon1.png" class="icon1" />
                <!-- <div class="header-ad"><a href="https://mp.weixin.qq.com/s/6cR6c0bRWXcTsc0re5Q_WQ">102人被查处！上海警方公布打击整治网络谣言典型案例！点我查看》》》</a></div> -->
                <img :src="appInfo.icon" class="header" />
                <div class="title">{{ appInfo.name }}</div>
                <div class="pwd-container">
                  <div class="t1">
                    {{ $t(`请输入`) }}{{ downType == "1" ? $t("密码") : $t("授权码") }}
                  </div>
                  <AInput
                    :placeholder="`${$t(`请输入`)}${
                      downType == '1' ? $t('密码') : $t('授权码')
                    }`"
                    v-model:value="dPassword"
                  />
                  <div class="btn hand" @click="toPwdDown">
                    {{ $t(`立即进入`) }}
                  </div>
                  <!-- <img :src="appInfo.qrCode" /> -->
                  <div style="width: 2.9rem; height: 2.9rem; margin: 0 auto;">
                    <QrCodes
                      :value="appDownQrCode"
                      :width="2.9 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 1">
                <img src="@/assets/download-icon1.png" class="icon1" />
                <!-- <div class="header-ad"><a href="https://mp.weixin.qq.com/s/6cR6c0bRWXcTsc0re5Q_WQ">102人被查处！上海警方公布打击整治网络谣言典型案例！点我查看》》》</a></div> -->
                <img :src="appInfo.icon" class="header" />
                <div class="title">{{ appInfo.name }}</div>
                <div class="tips" style="align-items: flex-start">
                  <div>
                    {{ $t(`版本`) }} {{ appInfo.ver }} {{ $t(`大小`) }}
                    {{ convertStorageSize(appInfo.size) }}
                  </div>
                  <div>{{ $t(`更新时间`) }} {{ appInfo.utime }}</div>
                </div>
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <downloadButton />
                <!-- <div
                  class="btn hand"
                  style="border-radius: 0.5rem; margin-top: 0.44rem"
                  @click="toDownloadLink"
                  v-if="showConfigBtn"
                >
                  {{ $t(`安装配置`) }}
                </div>
                <div
                  class="btn hand"
                  style="border-radius: 0.5rem; margin-top: 0.44rem"
                  @click="downloadBefore"
                  v-else-if="loadStatus == 0"
                >
                  {{ $t(`下载安装`) }}
                </div>
                <div
                  style="
                    font-size: 0.3rem;
                    margin-top: 0.3rem;
                    color: #78c22f;
                    text-align: center;
                  "
                  v-else-if="loadStatus == 1"
                >
                  {{ $t(`正在安装，请按home键返回桌面查看`) }}
                </div>
                <a
                  :href="configFileUrl"
                  v-else-if="loadStatus == 2 && !!configFileUrl && !isIos17"
                  @click="autoShowModal3"
                >
                  <div
                    class="btn hand"
                    style="border-radius: 0.5rem; margin-top: 0.44rem"
                  >
                    {{ $t(`信任开发`) }}
                  </div>
                </a>
                <div v-else-if="loadStatus == 2" @click="autoShowModal3">
                  <div
                    class="btn hand"
                    style="border-radius: 0.5rem; margin-top: 0.44rem"
                  >
                    {{ $t(`信任开发`) }}
                  </div>
                </div> -->
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
                <div class="flex-center flex-col" style="height: max-content">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <!-- <QrCode value="www.baidu.com" tag="img" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <!-- <downloadQrcode /> -->
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
                <div class="app-info-list">
                  <div class="app-info-item" v-if="appInfo.discription">
                    <div class="app-info-item-title">{{ $t(`应用描述`) }}</div>
                    <div class="app-info-item-content">
                      {{ appInfo.discription }}
                    </div>
                  </div>
                  <div class="app-info-item" v-if="appInfo.appIntro">
                    <div class="app-info-item-title">{{ $t(`应用介绍`) }}</div>
                    <div class="app-info-item-content">
                      {{ appInfo.appIntro }}
                    </div>
                  </div>
                  <div class="app-info-item" v-if="appInfo.qq">
                    <div class="app-info-item-title">{{ $t(`联系方式`) }}</div>
                    <div class="app-info-item-content">{{ appInfo.qq }}</div>
                  </div>
                  <div class="app-info-item" v-if="appInfo.remarks">
                    <div class="app-info-item-title">{{ $t(`备注`) }}</div>
                    <div class="app-info-item-content">
                      {{ appInfo.remarks }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 2">
                <img src="@/assets/download-icon1.png" class="icon1" />
                <div class="model-2-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="d-btn">
                      <downloadButton />
                    </div>
                  </div>
                </div>
                <div class="model-2-info-list">
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`版本`) }}</div>
                    <div>{{ appInfo.ver }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`大小`) }}</div>
                    <div>{{ convertStorageSize(appInfo.size) }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`更新时间`) }}</div>
                    <div class="font-20">{{ appInfo.utime }}</div>
                  </div>
                </div>
                <div class="flex-center flex-col">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 3">
                <img src="@/assets/model3-top.png" class="model-3-top" />
                <div class="model-3-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="model-3-btn">
                      <downloadButton />
                    </div>
                  </div>
                  <div class="flex-center flex-col modal-3-qrcode">
                    <div class="code">
                      <QrCodes
                        class="code"
                        :value="appDownQrCode"
                        :width="1.6 * cRem"
                        :logo="{
                          src: appInfo.icon,
                        }"
                      />
                    </div>
                    <!-- <img :src="appInfo.qrCode" class="code" /> -->
                    <!-- <QrCode value="www.baidu.com" tag="img" class="code" /> -->
                    <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                  </div>
                </div>
                <div class="model-2-info-list model-3-info-list">
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`版本`) }}</div>
                    <div>{{ appInfo.ver }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`大小`) }}</div>
                    <div>{{ convertStorageSize(appInfo.size) }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`更新时间`) }}</div>
                    <div class="font-20">{{ appInfo.utime }}</div>
                  </div>
                </div>
                <template v-if="appInfo.discription">
                  <div class="model-3-title">应用描述</div>
                  <div class="model-3-text">{{ appInfo.discription }}</div>
                </template>
                <template v-if="appInfo.appIntro">
                  <div class="model-3-title">应用备注</div>
                  <div class="model-3-text">{{ appInfo.appIntro }}</div>
                </template>
                <template v-if="appInfo.qq">
                  <div class="model-3-title">联系方式</div>
                  <div class="model-3-text">{{ appInfo.qq }}</div>
                </template>
                <div class="model-3-foot-line"></div>
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 4">
                <div class="model-2-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box flex1">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="d-btn" style="width: max-content">
                      <downloadButton />
                    </div>
                  </div>
                  <div class="flex-center flex-col">
                    <!-- <img :src="appInfo.qrCode" class="code" /> -->
                    <div class="code">
                      <QrCodes
                        class="code"
                        :value="appDownQrCode"
                        :width="2 * cRem"
                        :logo="{
                          src: appInfo.icon,
                        }"
                      />
                    </div>
                    <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                  </div>
                </div>
                <div class="model-2-info-list">
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`版本`) }}</div>
                    <div>{{ appInfo.ver }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`大小`) }}</div>
                    <div>{{ convertStorageSize(appInfo.size) }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`更新时间`) }}</div>
                    <div class="font-20">{{ appInfo.utime }}</div>
                  </div>
                </div>
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 5">
                <div class="model-2-header model-5-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box flex1">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="model-5-info-list">
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`版本`) }}</div>
                        <div>{{ appInfo.ver }}</div>
                        <div>{{ $t(`大小`) }}</div>
                        <div>{{ convertStorageSize(appInfo.size) }}</div>
                      </div>
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`更新时间`) }}</div>
                        <div class="font-20">{{ appInfo.utime }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <downloadButton />
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
                <div class="flex-center flex-col">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
              </template>
              <template v-else-if="pageModel == 6">
                <div class="model-2-header model-6-header">
                  <div class="name-box flex1 flex-center flex-col">
                    <img :src="appInfo.icon" class="img" />
                    <div class="name">{{ appInfo.name }}</div>
                  </div>
                </div>
                <div class="model-2-info-list">
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`版本`) }}</div>
                    <div>{{ appInfo.ver }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`大小`) }}</div>
                    <div>{{ convertStorageSize(appInfo.size) }}</div>
                  </div>
                  <div class="model-2-info-list-items">
                    <div>{{ $t(`更新时间`) }}</div>
                    <div class="font-20">{{ appInfo.utime }}</div>
                  </div>
                </div>
                <div class="flex-center flex-col">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <downloadButton />
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
              </template>
              <template v-else-if="pageModel == 7">
                <div class="model-7-top">
                  <div class="flex1">
                    {{ $t(`应用仅供内部测试，请谨慎辨别下载`) }}
                  </div>
                  <div class="model-7-top-btn-box">
                    <div class="model-7-top-btn-box-items" @click="showModal(5)">
                      {{ $t(`免责声明`) }}
                    </div>
                    <div class="model-7-top-btn-box-items" @click="showModal(4)">
                      {{ $t(`举报反馈`) }}
                    </div>
                  </div>
                </div>
                <div class="model-2-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box flex1">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="model-5-info-list" style="color: #777777">
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`版本`) }}</div>
                        <div>{{ appInfo.ver }}</div>
                        <div>{{ $t(`大小`) }}</div>
                        <div>{{ convertStorageSize(appInfo.size) }}</div>
                      </div>
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`更新时间`) }}</div>
                        <div class="font-20">{{ appInfo.utime }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <downloadButton />
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
                <div class="flex-center flex-col br-code shadow-code">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
              </template>
              <template v-else-if="pageModel == 8">
                <div class="model-7-top">
                  <div class="flex1">
                    {{ $t(`应用仅供内部测试，请谨慎辨别下载`) }}
                  </div>
                  <div class="model-7-top-btn-box">
                    <div class="model-7-top-btn-box-items" @click="showModal(5)">
                      {{ $t(`免责声明`) }}
                    </div>
                    <div class="model-7-top-btn-box-items" @click="showModal(4)">
                      {{ $t(`举报反馈`) }}
                    </div>
                  </div>
                </div>
                <div class="model-2-header">
                  <img :src="appInfo.icon" class="img" />
                  <div class="name-box flex1">
                    <div class="name">{{ appInfo.name }}</div>
                    <div class="model-5-info-list" style="color: #777777">
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`版本`) }}</div>
                        <div>{{ appInfo.ver }}</div>
                        <div>{{ $t(`大小`) }}</div>
                        <div>{{ convertStorageSize(appInfo.size) }}</div>
                      </div>
                      <div class="model-5-info-list-items">
                        <div>{{ $t(`更新时间`) }}</div>
                        <div class="font-20">{{ appInfo.utime }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <downloadButton />
                <div
                  class="hand"
                  @click="showModal(3)"
                  v-if="appInfo.type == 'ipa' && showGuide"
                  style="margin-bottom: 0"
                >
                  <img src="@/assets/donwload-icon4.png" />
                  <div>
                    {{
                      showConfigBtn
                        ? $t(`授权安装使用教程`)
                        : $t("未受信任的企业级开发者的解决办法")
                    }}
                  </div>
                </div>
                <div class="btn-tips hand" id="showModal2">
                  <!-- @click="showModal(2)" -->
                  <div @click="showModal(6)" style="max-width: 100%">
                    <Checkbox
                      v-model:checked="checked"
                      style="margin-left: 4px"
                      @click.stop
                    />
                    <div
                      v-html="
                        appInfo.recordNum
                          ? $t('该应用来源于第三方产品，请甄别风险后进行下载')
                          : $t('我已知晓内测应用的来源，并同意') +
                            '<br>' +
                            $t('自行承担下载此APP所带来的一切风险')
                      "
                    ></div>
                  </div>
                </div>
                <div class="flex-center flex-col shadow-code">
                  <!-- <img :src="appInfo.qrCode" class="code" /> -->
                  <div class="code">
                    <QrCodes
                      class="code"
                      :value="appDownQrCode"
                      :width="2 * cRem"
                      :logo="{
                        src: appInfo.icon,
                      }"
                    />
                  </div>
                  <div class="code-tips">{{ $t(`扫描二维码下载`) }}</div>
                </div>
              </template>
              <div class="flex1"></div>
              <div>
                <div
                  class="bottom-btn flex-center"
                  :class="{ 'bottom-btn-2': hideBottomBtnStyle }"
                >
                  <div class="flex-center hand" id="showModal2-2" @click="showModal(5)">
                    {{ $t(`免责声明`) }}
                  </div>
                  <div class="flex-center hand" @click="showModal(4)">
                    {{ $t(`举报反馈`) }}
                  </div>
                </div>
                <div class="flex-center">
                  <img
                    src="@/assets/icon.png"
                    @click="showInfo = true"
                    style="width: 22px; height: 22px; margin-right: 8px"
                  />
                  <div class="t-c" @click="showInfo = true">
                    {{ $t(`开发者信息`) }}
                  </div>
                </div>
                <div
                  class="model-2-bottom-tips"
                  v-if="showBottomTips"
                  @click="showModal(6)"
                >
                  该应用来源于第三方产品, 请甄别风险后进行下载
                  <img src="@/assets/tm-right.png" />
                </div>
                <div class="bottom-tips">
                  <div
                    style="margin-bottom: 14px"
                    class="flex-center"
                    v-if="appInfo.recordNum"
                  >
                    <img
                      src="@/assets/11.png"
                      alt=""
                      style="margin-right: 4px; width: 18px; height: 20px"
                    />
                    <div>{{ $t(`APP备案号`) }}：{{ appInfo.recordNum }}</div>
                  </div>
                  <div v-else>{{ $t(`应用仅供内部测试，请谨慎辨别下载`) }}</div>

                  <a
                    style="margin: 14px auto"
                    class="flex-center"
                    href="https://beian.miit.gov.cn/"
                    target="_blank"
                  >
                    <div style="color: #777777">{{ recordNumber }}</div>
                  </a>
                </div>
              </div>
              <div class="footer"></div>
            </div>
          </div>
        </div>
      </template>

      <div v-else class="error-page">
        <img src="@/assets/error.png" v-if="errorCode == -30010" style="" />
        <img src="@/assets/shoujichongzhi.png" v-else />
        <div class="text">{{ errorText }}</div>
        <div class="back flex-center">{{ $t(`返回`) }}</div>
      </div>
    </template>
    <template v-else>
      <div
        v-loading="true"
        style="
          width: 100vw;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <Spin size="large" />
      </div>
    </template>
    <div
      class="modal"
      @click="() => (modalShow = false)"
      v-show="modalShow"
      @touchmove.stop="
        () => {
          console.log('touch');
        }
      "
    >
      <!-- 
			1.移动端首页
			2.用户安装须知
			3."未受信任的企业级开发者"的解决办法
			4.反馈
			 -->
      <div class="modal-container modal-container_1" v-if="modalIndex == 1" @click.stop>
        <div class="modal-content">
          {{
            $t(
              `该应用为“咕噜分发”实名用户自行上传至咕噜分发使用CDN加速下载，未绑定自主域名内测。`
            )
          }}
        </div>
        <div class="modal-tip">
          {{ $t(`如发现违规应用，请你在跳转后点击举报`) }}
        </div>
        <div class="modal-btn hand" @click="hideModalFn">{{ $t(`确定`) }}</div>
      </div>
      <div class="modal-container modal-container_2" v-if="modalIndex == 2" @click.stop>
        <div class="modal-content">{{ $t(`用户安装须知`) }}</div>
        <div class="modal-tip">
          <div class="report">
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `1.咕噜分发平台对该等程序仅可进行初步的形式审查，无法详细分析每一应用程序的运行后果及风险。请您审慎地甄别应用程序的质量，切勿因为垃圾短信、邮件、文字说明等内容随意安装来源不可靠的应用程序，请根据应用安装链接的来源自行判断并安装可信任的应用程序。对于通过咕噜分发平台发布的应用程序或咕噜分发平台上展示的其他站点的链接，咕噜分发平台不对该程序或站点的规则、政策或具体内容负责。`
                )
              }}
            </p>
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `2.咕噜分发内测服务平台为第三方应用提供应用测试托管、应用分布式CDN加速下载服务。应用内容均来源于第三方产品，咕噜分发平台仅为用户提供内测支持，不涉及任何人工编辑和整理，也不参与任何应用的内容开发和对外运营，不对任何来源于第三方的内容（包括但不限于安装包安全、信息描述、应用截图）承担责任，您可根据描述场景谨慎选择进行内测试用。`
                )
              }}
            </p>
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `3.在您通过咕噜分发平台安装或使用应用程序的过程中，咕噜分发平台不会要求您提供任何个人信息，但我们无法控制亦无法保证应用程序开发者不会要求您提供个人信息。无论依据国家法律、法规的规定，应用程序开发者收集、使用您的个人信息应当遵循合法、正当、必要的原则，公开收集规则，向您明示收集、使用信息的目的、方式和范围，并且必须经过您的同意。应用程序开发者不得收集与其提供服务无关的个人信息，不得违反法律、法规规定或与您之间的约定收集、使用您的个人信息。如您在通过咕噜分发平台安装或使用应用程序的过程中被要求提供个人信息，请您审慎考虑并自行决定是否提供。`
                )
              }}
            </p>
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `4.任何公司、产品或者个人认为咕噜分发平台涉嫌侵犯您的版权或应用权，您应该及时向我们提供举报声明、书面权利通知，并提供身份证明、权属证明及侵权情况等投诉材料。我们将依法进行处理。`
                )
              }}
            </p>
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `5.咕噜分发平台的服务是按照现有技术和条件所能达到的现状提供的。咕噜分发平台会尽最大努力向您提供服务，确保服务的连贯性和安全性；但咕噜分发平台不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。即使咕噜分发平台提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为咕噜分发平台违约，同时，由此给您造成的数据或信息丢失等损失的，您同意放弃追究咕噜分发平台的责任。`
                )
              }}
            </p>
            <p style="padding-top: 20px; link-height: 10px">
              {{
                $t(
                  `6.咕噜分发平台平台所接触的内容和信息来源广泛，我方无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。咕噜分发平台不对用户在我方平台上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。我方平台在法律有明确规定的情况下承担相应的责任。`
                )
              }}
            </p>
          </div>
        </div>
        <div class="modal-btn hand" @click="hideModalFn">{{ $t(`确定`) }}</div>
      </div>
      <div class="modal-container modal-container_3" v-if="modalIndex == 3" @click.stop>
        <div class="modal-content">
          {{ $t(`未受信任的企业级开发者的解决办法`) }}
        </div>
        <div class="modal-tip">
          <img
            src="@/assets/code.png"
            style="width: 100%; height: auto"
            v-if="showConfigBtn"
          />
          <img src="@/assets/xrkf.png" style="width: 100%; height: auto" v-else />
        </div>
        <div class="modal-btn hand" @click="hideModalFn">{{ $t(`确定`) }}</div>
      </div>
      <div
        class="modal-container modal-container_4"
        v-if="modalIndex == 4"
        @click.stop
        @scroll.passive.capture.stop
      >
        <div class="modal-content">
          {{ $t(`未受信任的企业级开发者的解决办法`) }}
        </div>
        <div class="modal-tip" style="padding-bottom: 20px">
          <form action="" method="post">
            <div class="tit">{{ $t(`举报反馈`) }}</div>
            <p>
              {{
                $t(
                  `作为第三方内测分发平台，我们一直致力于打击违规应用，保护用户权益。非常感谢您的举报，我们会在第一时间安排专人处理您的举报问题。感谢您对我们的支持。`
                )
              }}
            </p>
            <div class="form-group">
              <label>{{ $t(`请选择举报类型`) }}<span>*</span></label>
              <ul class="clearfix form-ul flex">
                <li v-for="(item, key) in reportInfo.reportType" :key="key">
                  <input
                    type="radio"
                    :id="'radio-' + key"
                    :value="key"
                    v-model="reportForm.reportType"
                    class="hidden custom-radio"
                  />
                  <label :for="'radio-' + key">{{ item }}</label>
                </li>
              </ul>
              <div class="error">{{ $t(`请选择举报类型`) }}</div>
            </div>

            <div class="form-group">
              <label>{{ $t(`举报应用下载地址`) }}<span>*</span></label>
              <input
                type="text"
                class="form-control disabled"
                id="uurl"
                name="web_url"
                disabled
                :value="appInfo.dUrl"
              />
              <div class="error">{{ $t(`请输入举报应用下载地址`) }}</div>
            </div>

            <div class="form-group">
              <label>{{ $t(`举报理由`) }}<span>*</span></label>
              <select
                name="report_reason"
                id="report_reason"
                class="form-control"
                v-model="reportForm.reasonType"
              >
                <option
                  :value="key"
                  v-for="(item, key) in reportInfo.reasonType"
                  :key="key"
                >
                  {{ item }}
                </option>
              </select>
              <div class="error">{{ $t(`请选择举报理由`) }}</div>
            </div>

            <div class="form-group">
              <label>{{ $t(`是否造成金钱损失`) }}<span>*</span></label>
              <select
                name="report_money"
                id="report_money"
                class="form-control"
                v-model="reportForm.isLostMoney"
              >
                <option value="">{{ $t(`请选择是或否`) }}</option>
                <option value="1">{{ $t(`是`) }}</option>
                <option value="0">{{ $t(`否`) }}</option>
              </select>
              <div class="error">{{ $t(`请选择是否造成金钱损失`) }}</div>
            </div>

            <div class="form-group">
              <label>{{ $t(`举报原因`) }}<span>*</span></label>
              <textarea
                class="form-control"
                rows="4"
                id="report-content"
                :placeholder="$t(`补充举报原因`)"
                v-model="reportForm.reportReason"
              ></textarea>
              <div class="error">{{ $t(`请填写举报原因`) }}</div>
            </div>

            <div class="form-group">
              <label>Email</label>
              <input
                type="text"
                class="form-control"
                v-model="reportForm.email"
                name="email"
                placeholder="Email"
                id="report-email"
              />
            </div>

            <div class="form-group">
              <label>{{ $t(`你的手机号码`) }}<span>*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="reportForm.phone"
                name="mobile"
                :placeholder="$t(`你的手机号码`)"
                id="report-mobile"
              />
              <div class="error">{{ $t(`请填写手机号`) }}</div>
            </div>

            <div class="form-group">
              <label>{{ $t(`请输入短信验证码`) }}<span>*</span></label>
              <div class="flex" style="height: 40px">
                <input
                  type="text"
                  class="form-control"
                  v-model="reportForm.vcode"
                  name="code"
                  :placeholder="$t(`请输入短信验证码`)"
                  id="report-code"
                  style="width: 60%"
                />
                <button
                  id="sendcode"
                  style="flex-shrink: 0; color: white"
                  type="button"
                  class="ms-btn ms-btn-primary-new tm-bg"
                  @click="toSendCode"
                >
                  {{ codeTime <= 0 ? $t("获取验证码") : codeTime }}
                </button>
              </div>

              <div class="error">{{ $t(`请输入短信验证码`) }}</div>
            </div>

            <div class="btn-bottom">
              <button
                data-dismiss="modal"
                type="button"
                class="ms-btn color-hover-new tm-c"
                @click="hideModalFn"
              >
                {{ $t(`返回下载页`) }}
              </button>
              <button
                type="button"
                style="color: white"
                class="ms-btn ms-btn-primary-new save tm-bg"
                @click="uploadReport"
              >
                {{ $t(`举报`) }}
              </button>
            </div>
          </form>
        </div>
        <!-- <div class="modal-btn hand" @click="hideModalFn">确定</div> -->
      </div>
      <div
        class="modal-container modal-container_5 hide-scrollbar"
        v-if="modalIndex == 5"
        @click.stop
      >
        <div class="hide-scrollbar">
          <div style="padding: 10px" v-html="appInfo.disclaimer"></div>
        </div>
        <div class="modal-btn hand" @click="confirmModel5">
          {{ $t(`我同意`) }}
        </div>
      </div>
      <div
        class="modal-container modal-container_5 hide-scrollbar"
        v-if="modalIndex == 6"
        @click.stop
      >
        <div class="hide-scrollbar">
          <div style="padding: 10px" v-html="appInfo.agreement"></div>
        </div>
        <div class="modal-btn hand" @click="confirmModel5">
          {{ $t(`我同意`) }}
        </div>
      </div>
    </div>
    <div class="code-modal" @click="showCode = false" v-if="showCode">
      <slide-verify
        @click.stop
        ref="block"
        :imgs="verifyImgs"
        :slider-text="$t(`向右滑动`) + '->'"
        @success="toDownload"
      ></slide-verify>
    </div>
  </template>
  <template v-else>
    <AppView />
  </template>
  <Modal v-model:visible="showInfo" @ok="showInfo = false">
    <template #cancelText></template>
    <template #title>
      <div>{{ $t(`开发者信息`) }}</div>
    </template>
    <Descriptions>
      <DescriptionsItem :span="24" :label="$t(`开发者姓名`)">{{
        appInfo.realName
      }}</DescriptionsItem>
      <DescriptionsItem :span="24" :label="$t(`开发者手机号`)">{{
        appInfo.mobile
      }}</DescriptionsItem>
      <DescriptionsItem :span="24" :label="$t(`开发者邮箱`)">{{
        appInfo.email
      }}</DescriptionsItem>
    </Descriptions>
  </Modal>
</template>

<script lang="jsx" setup>
import getSecretStr from "@/utils/secretStr.js";
import { showModal2 } from "@/utils/showModal";
import {
  Input as AInput,
  Checkbox,
  Spin,
  message,
  Button,
  Modal,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { computed, nextTick, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import SlideVerify from "vue3-slide-verify";
import "vue3-slide-verify/dist/style.css";
import { apiDomain, request, request2 } from "@/request.js";
import { useI18n } from "vue-i18n";
import verifyImgs from "./imgs";
import AppView from "./App.vue";
import i18n from "@/locales";
import QrCodes from "@/components/Qrcode";

const checked = ref(false);
const t = i18n.global.t;
const downType = ref(0);
function hideModalFn() {
  modalShow.value = false;
}
// //正式api域名
// // const apiDomain = "https://web.gulufenfa.com"
// //测试api域名
// const apiDomain = "https://web.gulutest.com"
const showCode = ref(false);

const modalShow = ref(false);
const pageModel = ref(1);
const modalIndex = ref(0);
const isWeChat = ref(false);
const isPassword = ref(false);
const dPassword = ref("");
const errorCode = ref(0);
const showInfo = ref(false);
const router = useRouter();
const errorText = ref("应用不存在或已删除");
const isIos17 = ref(true);
const signId = ref(""); // 定义signId引用
const signIds = ref("");
const recordNumber = computed(() => {
  const host = window.location.hostname;
  if (host === "guluios.com") {
    return "沪ICP备18035940号-2";
  } else if (host === "www.gulu.cool") {
    return "沪ICP备18035940号-32";
  }
  return "沪ICP备18035940号-32"; // 默认值
});
nextTick(() => {
  isIos17.value = checkIos17();
});
const appInfo = ref({
  id: 0,
  name: "",
  icon: "",
  type: "",
  dUrl: "",
  qrCode: "",
  ver: "",
  size: 0,
  apk: "",
  discription: "",
  appIntro: "",
  qq: "",
  disclaimer: "",
  remarks: "",
  guidePage: 3,
});
const loadStatus = ref(0); // ios : 0 未点击安装 1 正在安装 2 安装完毕
const configFileUrl = ref("");
const route = useRoute();
const appCode = computed(() => {
  return route.params.id;
});
const enterCode = ref("");
const authCode = computed(() => {
  return enterCode.value || route.query.c;
});
const isAuthCode = computed(() => {
  return !!authCode.value || appInfo.value?.downType == 3||appInfo.value?.signId;
});
const authUDID = computed(() => {
  return route.query.UDID;
});
const isAuthCodeDownload = computed(() => {
  console.log("route.query.UDID", route.query.UDID);
  return (
    isAuthCode.value &&
    ((route.query.dec === "on" && authUDID.value) || appInfo.value.type == "apk")
  );
});
const hasDecUUID = computed(() => {
  return route.query.dec === "on" && authUDID.value;
});
const showConfigBtn = computed(() => {
  return isAuthCode.value && !isAuthCodeDownload.value && loadStatus.value == 0;
});
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const appDownQrCode = computed(() => {
  return appInfo.value.dUrl + '?source=' + (+new Date())
})
const getCodeCache = () => {
  try {
    let code = localStorage.getItem("code");
    if (code) {
      code = JSON.parse(code);
      if (code.includes(appCode.value)) {
        return true;
      }
    }
  } catch {}
  return false;
};

const setCodeCache = () => {
  try {
    let code = localStorage.getItem("code") || "[]";
    code = JSON.parse(code);
    if (!code.includes(appCode.value)) {
      code.push(appCode.value);
      localStorage.setItem("code", JSON.stringify(code));
    }
  } catch {}
};

const checkBrowser = () => {
  let ua = navigator.userAgent.toLowerCase();
  let isIosQQ =
    /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
    /\sQQ/i.test(navigator.userAgent);
  let isAndroidQQ =
    /(Android)/i.test(navigator.userAgent) &&
    /MQQBrowser/i.test(navigator.userAgent) &&
    /\sQQ/i.test(navigator.userAgent.split("MQQBrowser")) &&
    !/sogou/i.test(navigator.userAgent);
  return isIosQQ || isAndroidQQ || ua.match(/MicroMessenger/i) == "micromessenger";
};
isWeChat.value = checkBrowser();
// if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/QQ/i) == "qq") {
//   isWeChat.value = true;
//   // alert("用户正在使用微信内置浏览器打开网页！")
// } else {
//   // alert("用户没有使用微信打开网页！")
// }

function getDeviceType() {
  const userAgent = navigator.userAgent;
  // 判断用户设备类型
  if (/android/i.test(userAgent)) {
    // 用户设备是Android
    // return 'android'
    return "apk";
  } else if (/iPad|iPhone|iPod|Mac|mac/i.test(userAgent) && !window.MSStream) {
    // 用户设备是iOS
    return "ipa";
  } else {
    // 用户设备是PC或其他设备
    return "pc";
  }
}

const autoShowModal3 = () => {
  if (checkIos17()) {
    showModal(3);
  }
};

const checkIos17 = () => {
  try {
    const v = parseInt(ios_ver());
    return v >= 17;
  } catch {
    return false;
  }
};

const ios_ver = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/os (.*?) like mac os/)?.[1] || "000";
};

// setTimeout(() => {
//   if (getDeviceType() != appInfo.value.type) {
//     Modal.confirm({
//       title: '提示',
//       content: `改App只适用于${appInfo.value.type == 'ipa' ? 'iOS' : 'Android'}设备`,
//       okText: '确定',
//       cancelText: '取消',
//       onOk: () => {
//         console.log('OK')
//       }
//     })
//   }
// }, 1000);

const showError = ref(true);
const alreadyLoaded = ref(false);
const codeTime = ref(0);

const confirmModel5 = () => {
  checked.value = true;
  hideModalFn();
};

const reportInfo = ref({
  description: "",
  reportType: {},
  reasonType: {},
});

const reportForm = ref({
  reasonType: "0",
  reportType: "0",
  reportReason: "", // reportReason
  isLostMoney: "0",
  email: "",
  phone: "",
  vcode: "",
});

const codeTimeout = ref(0);

const toSendCode = async () => {
  try {
    if (codeTime.value > 0) return "";
    if (!reportForm.value.phone) throw t("请输入手机号");
    if (reportForm.value.phone?.length != 11) throw t("请输入正确的手机号");
    const data = {
      phone: reportForm.value.phone,
      type: 5,
    };
    const res = await request2(
      apiDomain + "/api/member/send-sms",
      {
        ...data,
        sign: getSecretStr(data),
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
        },
      }
    );
    if (res.status != 200 || res.data?.code != 0) throw res.data?.msg || "请求失败";
    message.success(t("发送成功"));
    codeTime.value = 10;
    codeTimeout.value = setInterval(() => {
      codeTime.value--;
      if (codeTime.value <= 0) {
        clearInterval(codeTimeout.value);
      }
    }, 1000);
  } catch (err) {
    showModal2({
      title: "提示",
      content: err,
      cancelText: "取消",
    });
  }
};

// const downloadCertificate = () => {
//   // app_name: appInfo.value.name,
//   // 			team: appInfo.value.team,
//   // 			bid: appInfo.value.bundle_id,
//   // 			uid: appInfo.value.uid,
//   request2(
//     apiDomain + "/api/download/trustDeveloper",
//     {
//       mpId: appInfo.value.certId,
//     },
//     {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
//       },
//     }
//   ).then((res) => {
//     if (res?.data?.code == 0) configFileUrl.value = res?.data?.data;
//     loadStatus.value = 2;
//     // const a = document.createElement('a');
//     // a.href = res.data.data
//     // a.style.display = 'none';
//     // document.body.appendChild(a);
//     // a.click();
//     // document.body.removeChild(a);
//   });
// };
const downloadCertificate = () => {
  request2(
    apiDomain + "/api/download/trustDeveloper",
    {
      mpId: appInfo.value.certId,
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
      },
    }
  )
    .then((res) => {
      if (res?.data?.code == 0) {
        configFileUrl.value = res?.data?.data; // 如果接口返回成功，保存配置文件 URL
        loadStatus.value = 2; // 设置为信任开发状态
      } else {
        // 如果接口返回错误码，但没有抛出异常
        showModal2({
          title: "提示",
          content: res?.data?.msg || "获取信任开发证书失败，请稍后重试！",
          hideConfirmBtn: true,
        });
      }
    })
    .catch((err) => {
      // 如果接口请求失败或抛出异常
      showModal2({
        title: "提示",
        content: err?.msg || err?.message || "请求失败，请稍后重试！",
        hideConfirmBtn: true,
      });
    });
};

const downloadLoading = ref(false);
const timer = ref(null);
const countdown = ref(6); // 倒计时时间，单位为秒
const isCounting = ref(false); // 是否正在倒计时
const downloadCompleted = ref(false); // 下载是否完成
const startCountdown = () => {
  isCounting.value = true; // 开始倒计时
  let countdownTime = 6; // 倒计时时间（秒）
  timer.value = setInterval(() => {
    countdownTime -= 1; // 每秒减少 1 秒
    countdown.value = countdownTime; // 更新倒计时显示
    console.log(countdown.value, "countdown.value");
    if (countdownTime <= 0) {
      clearInterval(timer.value); // 清除定时器
      isCounting.value = false; // 结束倒计时
      // if (signId.value) { // 如果有 signId，更新状态为 4
      //   loadStatus.value = 4;
      // } else {
      //   // 没有 signId 时的处理逻辑
      //   loadStatus.value = 2; // 设置为信任开发状态
      // }
      // if (!downloadCompleted.value) {
      //   // 倒计时结束但下载未完成，提示用户失败信息
      //   downloadLoading.value = false;
      //   showModal2({
      //     title: "提示",
      //     content: "签名任务超时，请稍后重试!",
      //     hideConfirmBtn: true,
      //   });
      // }
    }
  }, 1000);
};

const downloadBefore = () => {
  if (!checked.value) {
    message.warning(t("请同意风险声明"));
    return;
  }
  // appInfo.value.type
  console.log(getDeviceType());
  // if (getDeviceType() != appInfo.value.type) {
  //   Modal.warning({
  //     title: '提示',
  //     content: `该App只适用于${appInfo.value.type == 'ipa' ? 'iOS' : 'Android'}设备，ERR:`+navigator.userAgent,
  //     cancelText: '取消',
  //   })
  // } else {
  //   if (appInfo.value.downType == '2') {
  //     return showCode.value = true;
  //   }
  //   toDownload();
  // }

  if (appInfo.value.downType == "2") {
    return (showCode.value = true);
  }
  if (downloadLoading.value) return;
  loadStatus.value = 1; // 设置为正在安装状态
  downloadLoading.value = true;
  isCounting.value = true; // 启动倒计时
  // if (downloadLoading.value || isCounting.value) return;
  // downloadLoading.value = true;

  downloadCompleted.value = false; // 重置下载完成标志
  // 启动倒计时
  startCountdown();

  // 立即开始下载操作
  // toDownload();
  toDownload();
  isIos17.value = checkIos17();
};
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

const toPwdDown = async () => {
  const url =
    downType.value == "3" ? "/api/download/valiCode" : "/api/download/valiPassword";
  const params = {};
  console.log("downType.value", downType.value);
  if (downType.value == 3) {
    params.appId = appInfo.value.id;
    params.code = dPassword.value;
  } else {
    params.app_id = appInfo.value.id;
    params.pwd = dPassword.value;
  }
  request2(
    apiDomain + url,
    {
      ...params,
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
      },
    }
  )
    .then((res) => {
      console.log(res.data, "接口返回的什么呢");
      console.log(res.data.msg);
      if (res.status != 200 || res.data?.code != 0) throw res.data?.msg || "请求失败";
      if (res.data?.code == 0) {
        isPassword.value = false;
        if (downType.value == 3) {
          enterCode.value = dPassword.value;
          console.log("enterCode.value", enterCode.value);
        }
        // loadStatus.value = 0;
      } else {
        showModal2({
          title: "提示",
          content: res.data?.msg || "请求错误",
          cancelText: "取消",
        });
      }
    })
    .catch((err) => {
      showModal2({
        title: "提示",
        content: err?.msg || err || "请求失败!",
        cancelText: "取消",
      });
    });
};
const toDownloadLink = async () => {
  if (!checked.value) {
    message.warning(t("请同意风险声明"));
    return;
  }
  const res = await request(
    "/api/download/downMobileFile",
    {
      appid: appInfo.value.id,
      c: authCode.value,
      uuid: uuidv4(),
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  );
  window.location.href = res.link;
  console.log("到这里了听哦Down？");
  autoShowModal3();
  if(!checkIos17()){
    setTimeout(() => {
    window.location.href = res.url;
    // downloadCertificate();
  }, 2000);
  }
};
const codeSwitch = async () => {
  try {
    isPassword.value = true;
    const res = await request(
      "/api/download/codeSwitch",
      {
        appid: appInfo.value.id,
        udid: authUDID.value,
        UDID: authUDID.value,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }
    );
    if (res.show == 1) {
      isPassword.value = true;
    } else {
      isPassword.value = false;
    }
  } catch (e) {
    console.log(e);
    showError.value = true;
    errorText.value = e;
  }
};
const toDownload = () => {
  showCode.value = false;
  const params = {
    code: appCode.value,
    appid: appInfo.value.id,
    UDID: authUDID.value,
    nonceStr: uuidv4().substr(0, 16),
    pwd: dPassword.value,
    c: authCode.value,
    uuid: uuidv4(),
    IMEI: route.query?.IMEI,
    ICCID: route.query?.ICCID,
    CHALLENGE: route.query?.CHALLENGE,
    DEVICE_NAME: route.query?.DEVICE_NAME,
    DEVICE_VERSION: route.query?.DEVICE_VERSION,
    source: route.query?.source
  };
  request2(
    apiDomain + "/api/download/install",
    {
      ...params,
      sign: getSecretStr(params),
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
      },
    }
  )
    .then((res) => {
      console.log(res);
      if (res.status != 200 || res.data?.code != 0)
        throw { msg: res.data?.msg } || "请求失败";
      const data = res.data.data;
      signId.value = data.signId; // 正确更新 signId 的值
      console.log(data.signId, "data.signId上面的");
      if (signId.value) {
        // 如果有签名ID
        startPollingSignApp(signId.value); // 开始轮询签名状态
      } else {
        // 如果没有签名ID，直接下载
        if (checkPlistParam(data.apk)) {
          const a = document.createElement("a");
          // https://test.guludeveloper.com/source/pack/upload/install/ios.php?key=646C563F6F6S4650373C334N353G0'
          // "https://web.gulufenfa.com/page/download/plist?key=MTY5MjAyNzA1OJyygM7IfHmHj4+VnYCco6FuZGeUmquIuGl/mZBpaI2zgKKtz76ija2Qf9ydiomFoYiZe5zHa2nXjaF2qJiLopeDpmfTyGamoYJ7rqGaeXqOnJ2om7Sig9GYe4Kwg5+t3I98b9zIZ4StkGu6pJuKhqScY4Knvmty1ox2aLODiW/OkZCEz76eeLCDf7aahXl5aoead52ya4rcjWV2poKtg5mFa4OZv3uMsYSLmaGaeXlnnGKdoMejas+Cin2zjYqD4IZ9ntK/e4ixg6KtZpCsm7KTd35lvo2Clo2tfbKCd5DPhoyQlrWIkGiQf6lhhnl9sYKZqJvGkIfYlp+GspZ2f5yApp6WyXx5soWk26ePdW1rk4d6p79sj9WYi4Kll2aH25Brb9q9d3BpmX/cp5CJhrKRc2qayIF7xYBlnKOWZWvJg7N/3bKehK+FfKVij3VsaoeEnZ2yo53NgYd9aoF6iM+Eo3jQsoibpIR/qpmEnJdrh3SYrLKQipeNhmWwlqCZlZujZt6znqKxg3ytY4V2iWyCnmFv"
          // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0
          // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0

          //这种方式会触发在“iTunes”中打开此页?的提示
          // a.href = "itms-services://?action=download-manifest&url=" + encodeURIComponent(data.apk);
          //    a.style.display = 'none';
          //    document.body.appendChild(a);
          //    a.click();
          //    document.body.removeChild(a);

          //用重定向的方式则不会
          window.location.href =
            "itms-services://?action=download-manifest&url=" +
            encodeURIComponent(data.apk);

          loadStatus.value = 1;
          setTimeout(() => {
            downloadCertificate();
            downloadLoading.value = false;
          }, 3000);
        } else {
          try {
            if (isMobileDevice()) {
              window.location.href = data.apk;
              // axios.get(data.apk, {
              //   responseType: 'blob'
              // }).catch((err) => {
              //   console.log(err)
              // })
            } else {
              window.open(data.apk);
            }
          } catch {}
        }
      }
      // "https://web.gulufenfa.com/page/download/plist?key=MTY5MDIwNzYzOJyygM7IfHmHj4+VnYCco6FuZGeUmquIuGl/mZBpaI2zgKKtz76ija2Qf9ydiomFoYiZe5zHa2nXjaF2qJiLopeDpmfTyGamoYJ7rqGaeXqOnJ2om7Sig9GYe4Kwg5+t3I98b9zIZ4StkGu6pJuKhqScY4Knvmty1ox2aa2NiW/TkI9v4MZ7o56XpdCdg4Z9soZ0dmSyjZKVg4dxa4GHg96EomvWyHt8oYJ7rqGQZG2tj4h7pa6jqMuVe4Jpl3uDnI98b8mxZ5ukj6GZn5uJrGmdd4esyXxuzJZlYZyAZozdmYBvzr98hZuCaqqomnirrpqHf6jHpbDYgZ1xsoGtd5mEjYTJsWaMbY+iqWSRiXlsk3eCZ7+jg8+BoHlpg4d7l5CjeM+ye4hrkKW9YoRkhW2FnnOnv7NylISHdWuDh3ffhH2Z3bKunqGciaFu"
      // downloadFile(data.apk)
      console.log(checkPlistParam(data.apk));
      // if (checkPlistParam(data.apk)) {
      //   const a = document.createElement("a");
      //   // https://test.guludeveloper.com/source/pack/upload/install/ios.php?key=646C563F6F6S4650373C334N353G0'
      //   // "https://web.gulufenfa.com/page/download/plist?key=MTY5MjAyNzA1OJyygM7IfHmHj4+VnYCco6FuZGeUmquIuGl/mZBpaI2zgKKtz76ija2Qf9ydiomFoYiZe5zHa2nXjaF2qJiLopeDpmfTyGamoYJ7rqGaeXqOnJ2om7Sig9GYe4Kwg5+t3I98b9zIZ4StkGu6pJuKhqScY4Knvmty1ox2aLODiW/OkZCEz76eeLCDf7aahXl5aoead52ya4rcjWV2poKtg5mFa4OZv3uMsYSLmaGaeXlnnGKdoMejas+Cin2zjYqD4IZ9ntK/e4ixg6KtZpCsm7KTd35lvo2Clo2tfbKCd5DPhoyQlrWIkGiQf6lhhnl9sYKZqJvGkIfYlp+GspZ2f5yApp6WyXx5soWk26ePdW1rk4d6p79sj9WYi4Kll2aH25Brb9q9d3BpmX/cp5CJhrKRc2qayIF7xYBlnKOWZWvJg7N/3bKehK+FfKVij3VsaoeEnZ2yo53NgYd9aoF6iM+Eo3jQsoibpIR/qpmEnJdrh3SYrLKQipeNhmWwlqCZlZujZt6znqKxg3ytY4V2iWyCnmFv"
      //   // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0
      //   // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0

      //   //这种方式会触发在“iTunes”中打开此页?的提示
      //   // a.href = "itms-services://?action=download-manifest&url=" + encodeURIComponent(data.apk);
      //   //    a.style.display = 'none';
      //   //    document.body.appendChild(a);
      //   //    a.click();
      //   //    document.body.removeChild(a);

      //   //用重定向的方式则不会
      //   window.location.href =
      //     "itms-services://?action=download-manifest&url=" +
      //     encodeURIComponent(data.apk);

      //   loadStatus.value = 1;
      //   setTimeout(() => {
      //     downloadCertificate();
      //     downloadLoading.value = false;
      //   }, 3000);
      // } else {
      //   try {
      //     if (isMobileDevice()) {
      //       window.location.href = data.apk;
      //       // axios.get(data.apk, {
      //       //   responseType: 'blob'
      //       // }).catch((err) => {
      //       //   console.log(err)
      //       // })
      //     } else {
      //       window.open(data.apk);
      //     }
      //   } catch { }
      // }
      //   fetch(data.apk)
      //     .then(response => response.blob())
      //     .then(blob => {
      //       const url = URL.createObjectURL(blob);
      //       const a = document.createElement('a');
      //       a.href = url;
      //       a.download = 'filename.ext'; // 用实际文件名替换
      //       a.style.display = 'none';
      //       document.body.appendChild(a);
      //       a.click();
      //       document.body.removeChild(a);
      //       URL.revokeObjectURL(url);
      //     })
      //     .catch(error => {
      //       // 处理错误
      //     });
      // }).catch(err => {
      //   console.log(err);
      //   message.error(err?.msg || err?.message || err)
      //   // message.error(err)
      // 设置下载完成标志
      downloadCompleted.value = true;

      // 如果倒计时已经结束，则直接显示信任开发提示
      if (!isCounting.value) {
        console.log("到这里了吗倒计时结束");
        loadStatus.value = 2; // 设置为信任开发状态
      }
    })
    .catch((err) => {
      console.log("错误到这里了1111");
      loadStatus.value = 3;
      downloadLoading.value = false;
      clearInterval(timer.value); // 终止倒计时
      showModal2({
        title: "提示",
        content: err?.msg || err?.message || "请求失败!",
        hideConfirmBtn: true,
      });
      // Modal.warning({
      //   title: '提示',
      //   content: err?.msg || err?.message || '请求失败!',
      //   cancelText: '取消',
      // })
    });
};
// 更新后

// 签名接口
const pollingTimer = ref(null); // 存储轮询定时器的引用
const apkUrl = ref("");
let signData = null;
// const startPollingSignApp = (signId) => {
//   console.log("sstartPollingSignApp下的", signId);
//   let pollingInterval = 5000; // 轮询间隔时间（毫秒）
//   let maxRetries = 12; // 最大轮询次数（1分钟内轮询12次，每次5秒）
//   let retryCount = 0; // 当前轮询次数

//   const polling = () => {
//     if (retryCount >= maxRetries) {
//       // 超过最大轮询次数，停止轮询并提示用户失败信息
//       loadStatus.value = 3; // 设置为下载失败状态
//       console.log("loadStatus.value!",loadStatus.value);
//       downloadLoading.value = false;
//       showModal2({
//         title: "提示",
//         content: "签名任务超时，请稍后重试!",
//         hideConfirmBtn: true,
//       });
//       clearInterval(timer.value); // 终止倒计时
//       clearTimeout(pollingTimer.value); // 终止轮询定时器
//       return;
//     }
//     const currentSignId = signId;
//     console.log("currentSignId这个是singID哦", currentSignId);
//     request2(
//       apiDomain + "/api/download/signApp",
//       {
//         signId: signId,
//         appid: appInfo.value.id,
//       },
//       {
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
//         },
//       }
//     )
//       .then((res) => {
//         console.log("轮询签名状态:", res.data);
//         if (res.status == 200 && res.data?.code == 0) {
//           // 签名成功，获取下载地址
//           signData = res.data.data;
//           console.log("签名成功", signData);
//         } else {
//           // 签名失败或仍在进行中，继续轮询
//           retryCount++;
//           pollingTimer.value = setTimeout(polling, pollingInterval); // 重新设置轮询定时器
//           if (res.data?.msg) {
//             // 如果返回失败信息，弹出提示框
//             loadStatus.value = 3; // 设置为下载失败状态
//             console.log("loadStatus.value!",loadStatus.value);
//             showModal2({
//               title: "提示",
//               content: res.data.msg || "签名失败，请稍后重试!",
//               hideConfirmBtn: true,
//             });
//             clearInterval(timer.value); // 终止倒计时
//             clearTimeout(pollingTimer.value); // 终止轮询定时器
//           }
//         }
//       })
//       .catch((err) => {
//         // 请求失败，停止轮询并提示用户失败信息
//         loadStatus.value = 3; // 设置为下载失败状态
//         console.log("loadStatus.value!",loadStatus.value);
//         downloadLoading.value = false;
//         showModal2({
//           title: "提示",
//           content: err?.msg || err?.message || "请求失败!",
//           hideConfirmBtn: true,
//         });
//         clearInterval(timer.value); // 终止倒计时
//         clearTimeout(pollingTimer.value); // 终止轮询定时器
//       });
//   };

//   // 开始轮询
//   pollingTimer.value = setTimeout(polling, pollingInterval);
// };
const startPollingSignApp = (signId) => {
  // console.log("startPollingSignApp 下的 signId:", signId);
  let pollingInterval = 5000; // 轮询间隔时间（毫秒）
  let maxRetries = 12; // 最大轮询次数（1分钟内轮询12次，每次5秒）
  let retryCount = 0; // 当前轮询次数

  const polling = () => {
    // if (retryCount >= maxRetries) {
    //   // 超过最大轮询次数，停止轮询并提示用户失败信息
    //   loadStatus.value = 3; // 设置为下载失败状态
    //   console.log("loadStatus.value:", loadStatus.value);
    //   downloadLoading.value = false;
    //   showModal2({
    //     title: "提示",
    //     content: "签名任务超时，请稍后重试!",
    //     hideConfirmBtn: true,
    //   });
    //   clearInterval(timer.value); // 终止倒计时
    //   clearTimeout(pollingTimer.value); // 终止轮询定时器
    //   return;
    // }

    const currentSignId = signId;
    console.log("currentSignId 这个是 signID:", currentSignId);

    request2(
      apiDomain + "/api/download/signApp",
      {
        signId: signId,
        appid: appInfo.value.id,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8;",
        },
      }
    )
      .then((res) => {
        console.log("轮询签名状态:", res.data);
        if (res.status == 200 && res.data?.code == 0) {
          signData = res.data.data;
          console.log("signData:", signData);
          // 签名成功，获取下载地址
          const { status, apk } = res.data.data;
          if (status === 2) {
            console.log("2", status);
            // 签名成功
            loadStatus.value = 4; // 设置为签名成功状态
            // configFileUrl.value = apk; // 设置下载链接
            clearTimeout(pollingTimer.value); // 终止轮询定时器
          } else if (status === 1) {
            // console.log("1", status);
            // 签名中，继续轮询
            loadStatus.value = 6;

            retryCount++;
            pollingTimer.value = setTimeout(polling, pollingInterval);
            // return;
          } else if (status === 3) {
            // console.log("3", status);
            // 签名失败
            loadStatus.value = 3; // 设置为下载失败状态
            // configFileUrl.value = ''; // 清理下载链接
            showModal2({
              title: "提示",
              content: "签名失败，请稍后重试!",
              hideConfirmBtn: true,
            });
            clearInterval(timer.value); // 终止倒计时
            clearTimeout(pollingTimer.value); // 终止轮询定时器
          }
        } else {
          // 签名失败或仍在进行中，继续轮询
          retryCount++;
          pollingTimer.value = setTimeout(polling, pollingInterval);
        }
      })
      .catch((err) => {
        // 请求失败，停止轮询并提示用户失败信息
        loadStatus.value = 3; // 设置为下载失败状态
        console.log("loadStatus.value:", loadStatus.value);
        downloadLoading.value = false;
        showModal2({
          title: "提示",
          content: err?.msg || err?.message || "请求失败!",
          hideConfirmBtn: true,
        });
        clearInterval(timer.value); // 终止倒计时
        clearTimeout(pollingTimer.value); // 终止轮询定时器
      });
  };

  // 开始轮询
  pollingTimer.value = setTimeout(polling, pollingInterval);
};
const downloadApk = () => {
  if (checkPlistParam(signData.apk)) {
    console.log("downloadApk", signData.apk);
    const a = document.createElement("a");
    // https://test.guludeveloper.com/source/pack/upload/install/ios.php?key=646C563F6F6S4650373C334N353G0'
    // "https://web.gulufenfa.com/page/download/plist?key=MTY5MjAyNzA1OJyygM7IfHmHj4+VnYCco6FuZGeUmquIuGl/mZBpaI2zgKKtz76ija2Qf9ydiomFoYiZe5zHa2nXjaF2qJiLopeDpmfTyGamoYJ7rqGaeXqOnJ2om7Sig9GYe4Kwg5+t3I98b9zIZ4StkGu6pJuKhqScY4Knvmty1ox2aLODiW/OkZCEz76eeLCDf7aahXl5aoead52ya4rcjWV2poKtg5mFa4OZv3uMsYSLmaGaeXlnnGKdoMejas+Cin2zjYqD4IZ9ntK/e4ixg6KtZpCsm7KTd35lvo2Clo2tfbKCd5DPhoyQlrWIkGiQf6lhhnl9sYKZqJvGkIfYlp+GspZ2f5yApp6WyXx5soWk26ePdW1rk4d6p79sj9WYi4Kll2aH25Brb9q9d3BpmX/cp5CJhrKRc2qayIF7xYBlnKOWZWvJg7N/3bKehK+FfKVij3VsaoeEnZ2yo53NgYd9aoF6iM+Eo3jQsoibpIR/qpmEnJdrh3SYrLKQipeNhmWwlqCZlZujZt6znqKxg3ytY4V2iWyCnmFv"
    // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0
    // itms-services://?action=download-manifest&url=https%3A%2F%2Ftest.guludeveloper.com%2Fsource%2Fpack%2Fupload%2Finstall%2Fios.php%3Fkey%3D646C563F6F6S4650373C334N353G0

    //这种方式会触发在“iTunes”中打开此页?的提示
    // a.href = "itms-services://?action=download-manifest&url=" + encodeURIComponent(data.apk);
    //    a.style.display = 'none';
    //    document.body.appendChild(a);
    //    a.click();
    //    document.body.removeChild(a);

    //用重定向的方式则不会
    window.location.href =
      "itms-services://?action=download-manifest&url=" + encodeURIComponent(signData.apk);

    loadStatus.value = 5;
    console.log(loadStatus.value, "打印的localhost");
    setTimeout(() => {
      downloadCertificate();
      downloadLoading.value = false;
    }, 3000);
  } else {
    try {
      if (isMobileDevice()) {
        window.location.href = signData.apk;
        // axios.get(data.apk, {
        //   responseType: 'blob'
        // }).catch((err) => {
        //   console.log(err)
        // })
      } else {
        window.open(signData.apk);
      }
    } catch {}
  }
};

function checkPlistParam(url) {
  var regex = /.*?\/plist\?key/;
  return regex.test(url);
}

function downloadFile(url) {
  var fileName = url.substring(url.lastIndexOf("/") + 1);
  var link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const { locale } = useI18n();
const showGuide = ref(false);
onMounted(() => {
  request2(
    apiDomain + "/api/download/main",
    { code: appCode.value, source: route.query?.source },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  )
    .then((res) => {
      alreadyLoaded.value = true;
      signIds.value = res.data.data.signId;
      console.log(res, "接口返回的数据");
      let changeView = true;
      nextTick(() => {
        setTimeout(() => {
          if (res.data?.data?.domain_status == 1) {
            changeView = false;
            showBox2(false);
          }
          if (
            changeView &&
            window.innerWidth < 993 &&
            route.params.type != "U1qqG7+V91!Ah@pzA" &&
            !getCodeCache() &&
            !isAuthCodeDownload.value &&
            res.data?.data?.domain_status != 1
          ) {
            if (document.getElementById("app_1")) {
              document.getElementById("app_1").style.display = "flex";
            }
            if (document.getElementById("app_2")) {
              document.getElementById("app_2").style.display = "none";
            }
          }
        }, 10);
      });
      // console.log("value :", res);
      showError.value = true;
      errorCode.value = res?.data?.code;
      if (res.status != 200 || res.data?.code != 0) throw res.data?.msg || "请求失败";
      locale.value = res.data.data.tpl_lang;
      console.log("i18n.global.t", t(`我同意`));
      showGuide.value = res.data.data.showGuide == 1;
      appInfo.value = res.data.data;
      isPassword.value = appInfo.value.downType == "1";
      if (appInfo.value.recordNum) {
        checked.value = true;
      }
      // appInfo.value.template = 3;
      pageModel.value = appInfo.value.template;
      if ([2, 3, 4].includes(appInfo.value.template)) {
        dBtnStyle.value = "";
        dBtnClass.value = "";
      } else if ([5].includes(appInfo.value.template)) {
      }
      // if (appInfo.value.downType == "3" && !authCode.value) {
      // 	isPassword.value = true;
      // }
      if (appInfo.value.downType == "3") {
        // changeView = false;
        // nextTick(() => {
        // 	setTimeout(() => {
        // 		showBox2(false);
        // 	}, 20);
        // });
        if (hasDecUUID.value || appInfo.value.type == "apk") {
          codeSwitch();
        }
      }
      downType.value = appInfo.value.downType;
      showError.value = false;
      document.title = `${appInfo.value.name} ${document.title}`;
    })
    .catch((err) => {
      alreadyLoaded.value = true;
      showError.value = true;
      errorText.value = err;
      console.log("err:", err);
      // message.error(err)
    });

  request2(
    apiDomain + "/api/download/report",
    { code: appCode.value },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  )
    .then((res) => {
      console.log("value :", res);
      if (res.status != 200 || res.data?.code != 0) throw "请求失败";
      reportInfo.value = res.data.data;
    })
    .catch((err) => {
      console.log("err:", err);
    });
});
function toQuery() {
  let str = "";
  for (const key in route.query) {
    if (str != "") {
      str += "&";
    }
    str += key + "=" + route.query[key];
  }
  return str;
}
function showBox2(replaceUrl = true) {
  if (replaceUrl) {
    // router.replace(route.path + "/iframe?" + toQuery());
  }
  const box1 = document.getElementById("app_1");
  const box2 = document.getElementById("app_2");
  box1.style.display = "none";
  box2.style.display = "block";
  setCodeCache();
}

function showModal(index = 1) {
  modalShow.value = true;
  modalIndex.value = index;
  console.log(modalShow.value);
}

function convertStorageSize(totalSpace) {
  const units = ["B", "KB", "MB", "GB"];
  let size = totalSpace;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
}

function uploadReport() {
  if (!reportForm.value.phone) {
    return message.error(t("请填写手机号"));
  }
  if (!reportForm.value.vcode) {
    return message.error(t("请填验证码"));
  }
  console.log("reportInfo.value.id", reportInfo.value.id);
  request2(
    apiDomain + "/api/download/submit-report",
    { ...reportForm.value, reportAppId: appInfo.value.id },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
    }
  )
    .then((res) => {
      if (res.status != 200 || res.data?.code != 0) throw res.data?.msg || "请求失败";
      message.success(t("提交成功"));
      hideModalFn();
    })
    .catch((err) => {
      console.log("err:", err);
      message.error(err);
    });
}

const dVal = ref(0);
const dBtnStyle = ref({
    borderRadius: "0.5rem",
    marginTop: "0.44rem",
});
const dBtnClass = ref("btn hand");
// const downloadButton = computed(() => {
//   if (showConfigBtn.value) {
//     return (
//       <div
//         className={dBtnClass.value}
//         style={dBtnStyle.value}
//         onclick={toDownloadLink}
//       >
//         {t(`安装配置`)}
//       </div>
//     );
//   } else if (loadStatus.value == 0) {
//     return (
//       <div
//         className={dBtnClass.value}
//         style={dBtnStyle.value}
//         onclick={downloadBefore}
//       >
//         {t(`下载安装`)}
//       </div>
//     );
//   } else if (loadStatus.value == 1) {
//     return (
//       // <div className="home-tips">{t(`正在安装，请按home键返回桌面查看`)}</div>
//       <div className="home-tips">
//         {isCounting.value ? `${countdown.value}秒后开始下载` : t(`正在安装，请按home键返回桌面查看`)}
//       </div>
//     );
//   } else if (loadStatus.value == 2 && !!configFileUrl.value && !isIos17.value) {
//     return (
//       <a href={configFileUrl.value} onclick={autoShowModal3}>
//         <div className={dBtnClass.value} style={dBtnStyle.value}>
//           {t(`信任开发`)}
//         </div>
//       </a>
//     );
//   } else if (loadStatus.value == 2) {
//     return (
//       <div
//         className={dBtnClass.value}
//         style={dBtnStyle.value}
//         onclick={() => autoShowModal3()}
//       >
//         {t(`信任开发`)}
//       </div>
//     );
//   }
// });
// 修改后
// if (signId.value) {
//   console.log('到这里来了吗')
//   startCountdown(); // 启动倒计时
// }
const downloadButton = computed(() => {
  if (showConfigBtn.value) {
    return (
      <div className={dBtnClass.value} style={dBtnStyle.value} onclick={toDownloadLink}>
        {t(`安装配置`)}
      </div>
    );
  } else if (loadStatus.value == 0) {
    return (
      <div className={dBtnClass.value} style={dBtnStyle.value} onclick={downloadBefore}>
        {t(`下载安装`)}
      </div>
    );
  } else if (loadStatus.value == 1) {
    return signId.value ? (
      <div className="home-tips">{t(`应用签名中请稍等...`)}</div>
    ) : (
      <div className="home-tips">{t(`正在安装，请按home键返回桌面查看`)}</div>
    );

    // <div className="home-tips">
    // {`${countdown.value}秒后超级签下载`}
    //   {`${countdown.value}秒后开始下载`}
    // </div>
  }
  // 新加入的失败
  else if (loadStatus.value == 3) {
    // 修改为下载失败状态
    return <div className="home-tips">{t(`下载失败，请重试`)}</div>;
  } else if (loadStatus.value == 5) {
    return <div className="home-tips">{t(`正在安装，请按home键返回桌面查看`)}</div>;
  } else if (loadStatus.value == 6) {
    return <div className="home-tips">{t(`应用签名中请稍后...`)}</div>;
  } else if (loadStatus.value == 4) {
    return (
      <div className="download-btn" style={dBtnStyle.value} onclick={downloadApk}>
        安装下载
      </div>
    );
  } else if (loadStatus.value == 2 && !!configFileUrl.value && !isIos17.value) {
    return (
      <a href={configFileUrl.value} onclick={autoShowModal3}>
        <div className={dBtnClass.value} style={dBtnStyle.value}>
          {t(`信任开发`)}
        </div>
      </a>
    );
  } else if (loadStatus.value == 2) {
    return (
      <div
        className={dBtnClass.value}
        style={dBtnStyle.value}
        onclick={() => autoShowModal3()}
      >
        {t(`信任开发`)}
      </div>
    );
  }
});

const hideBottomBtnStyle = computed(() => {
  return pageModel.value == 2 || pageModel.value == 3;
});
const showBottomTips = computed(() => {
  return pageModel.value == 2 || pageModel.value == 3;
});

const downloadQrcode = computed(() => {
  return (
    <QrCode imgclass="code2" value={appInfo.value.dUrl} image={appInfo.value.icon} />
  );
});
const cRem = computed(() => {
  const width = document.documentElement.clientWidth;
  const val = width / 7.5;
  if (width >= 471) {
    return 63
  }
  return val > 750 ? 750 : val;
});
</script>

<style lang="less">
.download-btn {
  width: 50%;
  padding: 8px;
  margin: 10px auto;
  text-align: center;
  background: #78c22f;
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
}

body {
  overflow: hidden;
}

.home-tips {
  font-size: 0.3rem;
  margin-top: 0.3rem;
  color: #78c22f;
  text-align: center;
  // border:1px solid red;
}

#app_1 {
  display: none;
}

#app_2 {
  display: block;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #78c22f !important;
}

* {
  /* 显示滚动条，但仅在必要时显示 */
  &::-webkit-scrollbar {
    display: none;
    /* 隐藏Webkit浏览器中的滚动条 */
  }
}

.hide-scrollbar {
  overflow: auto;

  /* 显示滚动条，但仅在必要时显示 */
  &::-webkit-scrollbar {
    display: none;
    /* 隐藏Webkit浏览器中的滚动条 */
  }
}

.ant-checkbox-inner {
  border-color: #78c22f !important;

  &:focus {
    border-color: #78c22f !important;
  }
}

.confirm-modals {
  // min-width: 408px !important;
  .custom-modal-content {
    margin-top: 0 !important;
  }

  .ant-modal-confirm-content {
    margin-top: 18px !important;
  }

  .cancel-btn {
    width: 156px !important;
    height: 40px !important;
    border: 1px solid #dddddd !important;
    border-radius: 25px !important;
    margin-right: 12px;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333333;
    text-align: center;
  }

  .ant-modal-confirm-title {
    text-align: center !important;
  }

  .confirm-btn {
    width: 156px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    background: #78c22f;
    border-radius: 25px;
  }
}

.hidden-button .ant-modal-confirm-btns {
  display: none !important;
}

* {
  margin: 0;
  padding: 0;
}

:root {
  font-size: calc(100vw / 7.5);
}

.custom-modal-content {
  margin: 30px auto 0 !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  color: #000000 !important;
  text-align: center !important;

  .custom-modal-content-confirm-btn {
    width: 156px;
    height: 40px;
    background: #78c22f;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    margin: 30px auto 0;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
  }
}

.code-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-modal-content {
  padding: 10px 30px 30px !important;

  @media screen and (max-width: 992px) {
    padding: 0.1rem !important;
  }
}

.ant-modal-header {
  @media screen and (max-width: 992px) {
    margin-bottom: 0 !important;
    text-align: center !important;
  }
}

.ant-modal-close {
  margin-top: 10px !important;
}

.ant-modal-content,
.ant-modal-header {
  border-radius: 12px !important;
}

.ant-modal-header {
  border: none !important;
  margin-bottom: 30px;
}

.ant-modal-header .ant-modal-title {
  font-weight: 400 !important;
  font-size: 18px !important;
  color: #000000 !important;
}

.error-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  font-size: 0.34rem;
  color: #777777;

  .back {
    width: 4.22rem;
    height: 0.8rem;
    border-radius: 0.44rem;
    background-image: linear-gradient(270deg, #a7de05 0%, #77cc23 63%);
    color: white;
    // font-size: 32px;
    font-size: 0.32rem;
    margin-top: 0.8rem;
  }

  img {
    // width: 4.86rem;
    width: auto;
    height: 2.8rem;
    margin-bottom: 0.28rem;
  }
}

.form-ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > li {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 10px;
  }
}

.container {
  width: 7.5rem;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tip1 {
  width: 0.36rem;
  height: 0.36rem;
  margin: 0.88rem;
}

.tm-bg {
  background: #78c22f !important;
  border-color: #78c22f !important;
}

.tm-c {
  color: #78c22f !important;
  border-color: #78c22f !important;
}

.bg {
  width: 5.3rem;
  height: 4.64rem;
}

.flex1 {
  flex: 1;
}

.flex {
  display: flex;
}

.tip-content-box {
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.tip-content-box img {
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.26rem;
}

.tip-content-title {
  font-size: 0.32rem;
}

.tip-content-text {
  font-size: 0.24rem;
  width: 5.26rem;
}

.next-btn {
  flex-shrink: 0;
  width: 5.24rem;
  height: 1rem;
  background-image: linear-gradient(168deg, #89e231 0%, #78c22f 100%);
  border-radius: 0.5rem;
  font-size: 0.36rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.62rem;
}

.p-180 {
  height: 1.8rem;
  /* flex-shrink: 2; */
  /* order: -1; */
  flex-shrink: 2;
}

.app-info-list {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  margin-left: 1rem;
}

.app-info-item {
  margin: 0.1rem 0;
}

.app-info-item-title {
  font-size: 20px;
  font-weight: 400;
  color: #333;
}

.app-info-item-content {
  font-weight: 400;
  font-size: 14px;
  color: #555;
  margin-top: 0.05rem;
}

.modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  /* display: flex; */
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 5.8rem;
  min-height: 4.82rem;
  max-height: 60%;
  // overflow: scroll;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #ffffff;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 993px) {
    width: 7.5rem;
  }
}

/* 隐藏原始的单选按钮 */
input[type="radio"] {
  display: none;
}

/* 自定义单选按钮的样式 */
input[type="radio"] + label {
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

/* 定义选中时的样式 */
input[type="radio"]:checked + label {
  background-color: #81d330;
  /* 换成您想要的颜色 */
  color: white;
  /* 换成您想要的颜色 */
}

.modal-content {
  font-size: 0.28rem;
  color: #333;
  width: 4.84rem;
  text-align: center;
  margin-top: 0.68rem;
}

.modal-tip {
  width: 95%;
  text-align: center;
  font-size: 0.24rem;
  color: #999;
  margin-top: 0.24rem;
}

.modal-btn {
  width: 3.05rem;
  height: 0.88rem;
  border: 0.02rem solid #81d330;
  border-radius: 0.44rem;
  color: #81d330;
  font-size: 0.32rem;
  display: flex;
  margin-top: 0.24rem;
  flex-shrink: 0;
  margin-bottom: 5px;
  justify-content: center;
  align-items: center;
}

.download-container {
  margin: 0 auto;
  width: 7.5rem;
  height: 100vh;
  overflow: scroll;
  // padding-top: 126px;

  .pwd-container {
    width: 70%;
    padding: 20px;
    margin: 0 auto;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .btn {
      width: 200px;
      height: 40px;
      background: #81d330;
      border-radius: 40px;
      margin: 20px auto 0;
      font-size: 16px;
    }

    .t1 {
      color: #666;
      text-align: center;
      margin-bottom: 10px;
    }

    img {
      width: 100%;
      height: auto;
      margin: 0.4rem auto 0.1rem;
    }
  }
}

.c-scroll {
  overflow: scroll;
}

#app_2 {
  position: relative;
}

.download-container .icon1 {
  width: 750px;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
}

.download-container .header {
  margin: calc(126px + 0.1rem) auto 0.1rem;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.3rem;
}

.header-ad {
  padding: 0.1rem 0.2rem;
  height: 126px;
  position: absolute;
  display: flex;
  align-items: center;

  a {
    color: #333;
    text-decoration: none;
  }
}

.download-container .title {
  margin: 0.18rem 0.2rem;
  color: #333333;
  text-align: center;
  font-size: 0.36rem;
}

.download-container .tips {
  color: #999999;
  text-align: center;
  font-size: 0.24rem;
}

.download-container .hand {
  color: #409cff;
  font-size: 0.24rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.3rem 0 0.44rem 0;
}

.download-container .hand img {
  width: 0.36rem;
  margin-right: 5px;
  height: 0.32rem;
}

.download-container .btn {
  width: 3.84rem;
  height: 1rem;
  background: linear-gradient(168deg, #89e231 0%, #78c22f 100%);
  // border-radius: 0.5rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 600;
  font-size: 0.36rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.download-container .btn-tips {
  width: 7.5rem;
  height: 0.36rem;
  font-size: 0.24rem;
  color: #78c22f;
  text-align: center;
  line-height: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.58rem;
}

.download-container .btn-tips .btn-tips-box {
  margin-left: 0.1rem;
  background: #78c22f;
  width: 0.36rem;
  height: 0.36rem;
  border-radius: 50%;
}

.download-container .btn-tips img {
  width: 0.1rem;
  height: 0.16rem;
}

.download-container .code {
  width: 2.02rem;
  height: 2.02rem;
  margin: 0 auto 0;
}

.download-container .code-tips {
  font-weight: 400;
  color: #999999;
  text-align: center;
  font-size: 0.24rem;
}

.download-container .bottom-btn div {
  color: white;
  font-size: 0.24rem;
  width: max-content;
  padding: 2px 8px;
  height: 0.56rem;
  border-radius: 0.28rem;
  opacity: 0.5;
}

.download-container .bottom-btn > div:nth-child(1) {
  background: #409cff;
}

.download-container .bottom-btn > div:nth-child(2) {
  background: #e87272;
  margin-left: 0.24rem;
}

.bottom-btn-2 {
  > div {
    background: none !important;
    color: #333 !important;
    opacity: 1 !important;
  }
}

.download-container .bottom-tips {
  // height: 0.36rem;
  font-weight: 400;
  font-size: 0.24rem;
  color: #777777;
  line-height: 0.36rem;
  text-align: center;
  margin: 0.2rem auto 10px;
}

.download-container .flex1 {
  flex: 1;
}

// @media screen and (max-width: 992px) {
//   #app_1 {
//     display: flex;
//   }

//   #app_2 {
//     display: none;
//   }
// }

@media screen and (min-width: 471px) {
  :root {
    font-size: 63px;
  }
}

@media screen and (min-width: 993px) {
  #app_1 {
    display: none;
  }

  #app_2 {
    display: block;
  }
}

/* Add your custom CSS styles here */
/* For example: */
.form-group {
  margin-top: 5px;
}

.form-group label {
  font-weight: bold;
  text-align: left;
  width: 100%;
  display: block;
  color: #333;

  span {
    color: red;
  }
}

.form-group input[type="text"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  font-size: 14px;
  text-align: left;
}

.form-group select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* background: url("select-arrow.png") no-repeat right center; */
  background-size: 16px;
  padding-right: 24px;
  text-align-last: left;
}

.form-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.form-group li {
  margin-bottom: 10px;
  text-align: left;
}

.form-group li span {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
}

.form-group li span.selected {
  background-color: #00aaff;
  border-color: #00aaff;
}

.form-group .error {
  color: #ff0000;
  font-size: 12px;
  margin-top: 5px;
  display: none;
  text-align: left;
}

.btn-bottom {
  margin-top: 20px;
  text-align: left;
  display: flex;
  justify-content: space-between;
}

/* Add your custom CSS styles here */
/* For example: */
.ms-btn {
  display: inline-block;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.ms-btn:hover {
  background-color: #f5f5f5;
}

.ms-btn-primary-new {
  background-color: #00aaff;
  color: #fff;
  border-color: #00aaff;
}

.ms-btn-primary-new:hover {
  background-color: #0099dd;
  border-color: #0099dd;
}

.color-hover-new {
  color: #00aaff;
}

.modal-container {
  display: flex;
}

.wechat {
  width: 100vw;
  height: 100vh;
  background: #4b4d5c;
  overflow: scroll;
  position: relative;

  .top-arrow {
    position: absolute;
    top: 0.22rem;
    right: 0.23rem;
    width: 1.51rem;
    height: 2.23rem;
  }

  .wechat-blue {
    width: 7.48rem;
    height: auto;
    margin: 0 auto;
  }

  .wechat-bg {
    width: 6.42rem;
    height: auto;
    margin: 0 auto;
  }

  .wechat-text {
    padding: 0 0.54rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem;

    &.m-t-2 {
      margin-top: 2rem;
    }

    &:last-child {
      margin-bottom: 0;
    }

    > div {
      &:first-child {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.12rem;
        background: #89e231;
        color: white;
      }

      &:last-child {
        opacity: 0.5;
        color: #ffffff;
        font-size: 0.32rem;
        font-weight: 400;
        text-align: left;
        margin-left: 0.18rem;
      }
    }
  }
}

.ant-btn-primary {
  background: linear-gradient(168deg, #89e231 0%, #78c22f 100%) !important;
  border-color: #78c22f !important;
  color: white;
}

.t-c {
  color: #78c22f;
}

.footer {
  height: 100px;
}

.model-5-header {
  background: #78c22f;
  position: relative;

  &::after {
    content: "";
    z-index: -1;
    background: url("@/assets/model5-bg.png") no-repeat;
    background-size: 100%;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .name-box {
    .name {
      color: white;
    }
  }
}

.model-7-top-btn-box {
  display: flex;

  .model-7-top-btn-box-items {
    padding: 0.04rem 0.08rem;
    border: 0.02rem solid #e87272;
    border-radius: 0.08rem;
    margin-left: 0.14rem;
  }
}

.model-7-top {
  color: #e87272;
  font-size: 0.24rem;
  font-weight: 400;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  padding: 0.26rem 0.42rem;
  background: #f2f2f2;
}

.br-code {
  position: fixed;
  bottom: 70px;
  right: 30px;
  z-index: 9;
}

.shadow-code {
  box-shadow: 0 4px 20px 0 #00000040;
  width: max-content;
  margin: 0 auto;
}

.model-5-info-list {
  color: #ffffff;
  font-size: 12px;
  font-weight: 300;

  .model-5-info-list-items {
    .flex;
  }
}

.model-6-header {
  background: linear-gradient(180deg, #91c4384c 0%, #ffffff00 100%);
}

.model-2-header {
  position: relative;
  z-index: 2;
  display: flex;
  padding: 0.68rem 0.38rem 0.36rem;

  .img {
    width: 1.76rem;
    height: 1.76rem;
    border-radius: 0.34rem;
  }

  .name-box {
    margin-left: 0.28rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .d-btn {
      border-radius: 0.1rem;
      background: linear-gradient(168.1deg, #89e231 0%, #78c22f 100%);
      font-size: 0.24rem;
      color: white;
      padding: 0.1rem 0.32rem;
    }
  }

  .name {
    font-size: 0.36rem;
    color: #000;
    font-weight: 500;
  }
}

.model-2-info-list {
  color: #777;
  margin: 0 0.38rem;
  padding: 0.3rem 0;
  display: flex;
  justify-content: center;
  border-top: 0.02rem solid #ddd;
  border-bottom: 0.02rem solid #ddd;
  box-sizing: border-box;

  .model-2-info-list-items {
    box-sizing: border-box;
    font-size: 0.28rem;
    border-right: 0.02rem solid #ddd;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.model-2-bottom-tips {
  display: flex;
  justify-content: center;
  font-size: 0.24rem;
  align-items: center;
  margin-top: 0.26rem;
  color: #777777;

  img {
    margin-left: 0.13rem;
    width: 0.36rem;
    height: 0.36rem;
  }
}

// 模版-3
.model-3-top {
  width: 7.5rem;
  height: 3.54rem;
}

.model-3-header {
  display: flex;
  padding: 0.3rem 0 0.34rem 0.36rem;
  position: relative;

  .img {
    margin-right: 0.24rem;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 0.34rem;
  }

  .name {
    font-size: 0.36rem;
    color: #000;
    font-weight: 500;
    margin: 0.08rem 0 0.04rem;
  }

  .modal-3-qrcode {
    position: absolute;
    top: -1.24rem;
    // top: 0;
    right: 0.2rem;

    .code {
      width: 1.6rem;
      height: 1.6rem;
      margin-top: 0 !important;
    }

    .code-tips {
      font-size: 0.24rem;
    }
  }
}

.model-3-title {
  font-weight: 500;
  font-size: 0.36rem;
  margin-left: 0.36rem;
  margin-bottom: 0.06rem;
}

.model-3-text {
  font-size: 0.24rem;
  font-weight: 400;
  color: #777;
  margin-bottom: 0.36rem;
  margin-left: 0.36rem;
}

.model-3-info-list {
  border-bottom: none;
}

.model-3-foot-line {
  width: 6.8rem;
  height: 0.02rem;
  background: #ddd;
  margin: 0 auto;
}

.model-3-btn {
  border-radius: 0.5rem;
  background: linear-gradient(168.1deg, #89e231 0%, #78c22f 100%);
  padding: 0.1rem 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.font-20 {
  font-size: 0.2rem;
}

.year-75 {
  width: 200px;
  z-index: 1;
  position: fixed;
  pointer-events: none
}
</style>
